import { ReactNode } from 'react'
import { Category, Description, EditNote, Home, MenuBook, People } from '@mui/icons-material'
import { com } from '@eidu/form'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

export const iconForEntityTypeKind = (kind: EntityTypeKind, fallbackIcon: ReactNode = <EditNote />): ReactNode => {
  switch (kind) {
    case EntityTypeKind.User:
      return <People />
    case EntityTypeKind.School:
      return <Home />
    case EntityTypeKind.Generic:
      return <Category />
    case EntityTypeKind.LearningUnit:
      return <MenuBook />
    case EntityTypeKind.Form:
      return <Description />
    default:
      return fallbackIcon
  }
}

export default iconForEntityTypeKind
